import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

var IncompleteDataMessages = createReactClass({
  propTypes: {
    messages: PropTypes.array.isRequired
  },

  render() {
    var style = { color: 'red' };

    var messages = this.props.messages.map(message =>
      <li>{message}</li>
    );

    return (
      <div style={style}>
        <ul>
          {messages}
        </ul>
      </div>
    );
  }

});

export default IncompleteDataMessages;



// WEBPACK FOOTER //
// ./src/components/common/IncompleteDataMessages.js